export const PAYMENT_SUCCESS = 'success';
export const PAYMENT_WAITING = 'waiting';
export const PAYMENT_PREORDER_PENDING = 'preorder_pending';



// WEBPACK FOOTER //
// ./app/constants/paymentStatus.js